export default __webpack_public_path__ + "static/media/yellow.2a3b8a6e.jpg";